module.exports = __webpack_public_path__ + "img/IMG_9431.b0c935d6.jpg";